import React from 'react';
import { Card, Box, HStack, Text, Separator } from '@chakra-ui/react';
import { HiUser, HiKey } from 'react-icons/hi';

interface ProfileMenuProps {
  onEditProfile: () => void;
  onChangePassword: () => void;
}

const ProfileMenu: React.FC<ProfileMenuProps> = ({ onEditProfile, onChangePassword }) => (
  <Card.Root w="full" variant="elevated" bg="white/80" borderRadius="2xl">
    <Card.Body p={0}>
      <Box
        as="button"
        w="full"
        py={3}
        px={4}
        onClick={onEditProfile}
        _hover={{ bg: 'gray.50' }}
        transition="background 0.2s"
        borderTopRadius="2xl"
      >
        <HStack justify="space-between">
          <HStack gap={3}>
            <HiUser className="text-gray-800" size={18} />
            <Text fontSize="sm" fontWeight="medium" color="gray.800">
              プロフィール編集
            </Text>
          </HStack>
        </HStack>
      </Box>
      <Separator />
      <Box
        as="button"
        w="full"
        py={3}
        px={4}
        onClick={onChangePassword}
        _hover={{ bg: 'gray.50' }}
        transition="background 0.2s"
        borderBottomRadius="2xl"
      >
        <HStack justify="space-between">
          <HStack gap={3}>
            <HiKey className="text-gray-800" size={18} />
            <Text fontSize="sm" fontWeight="medium" color="gray.800">
              パスワード変更
            </Text>
          </HStack>
        </HStack>
      </Box>
    </Card.Body>
  </Card.Root>
);

export default ProfileMenu;
